<template>
  <v-container>
    <div id="divPrint">
      <div>
        <span  style="font-weight: bold">Identificación:</span>
          {{$store.state.patient.identification}}<br>
        <span style="font-weight: bold">Apellidos y nombres:</span>
          {{$store.state.patient.firstLastName}}
          {{$store.state.patient.secondLastName}}
          {{$store.state.patient.firstName}}
          {{$store.state.patient.secondName}} <br>
        <span style="font-weight: bold">Edad:</span>
          {{$store.state.patient.age}}<br>
        <span  style="font-weight: bold">Empresa:</span>
          {{$store.state.patient.company.name}}<br>
        <span  style="font-weight: bold">Puesto de trabajo:</span>
          {{$store.state.patient.jobCompany}}<br>
      </div>
    <table border="1">
      <tbody><tr><td colspan="3" align="center" bgcolor="#CCCCFF" width="1500px"><b>SCORE SD METABÓLICO</b></td></tr>
      <tr>
        <td bgcolor="#CCAAFF"><b>Descripción<b></b></b></td>
        <td bgcolor="#CCAAFF"><b>Valor<b></b></b></td>
        <td bgcolor="#CCAAFF"><b>Interpretación<b></b></b></td>
      </tr>
      <tr>
        <td>PERÍMETRO ABDOMINAL:</td>
        <td>{{this.$store.state.anamnesis.signosVitales[9].valor}}</td>
        <td>{{this.getPerimetro}}</td>

      </tr>
      <tr>
        <td>TRIGLICERIDOS:</td>
        <td>{{this.$store.state.anamnesis.signosVitales[11].valor}}</td>
        <td v-if="true">{{this.getTrigliceridos}}</td>

      </tr>
      <tr>
        <td>HDL:</td>
        <td>{{this.$store.state.anamnesis.signosVitales[12].valor}}</td>
        <td v-if="true">{{this.getHdl}}</td>

      </tr>
      <tr>
        <td>PRESIÓN:</td>
        <td>{{this.$store.state.anamnesis.signosVitales[1].valor}} / {{this.$store.state.anamnesis.signosVitales[2].valor}}</td>
        <td>{{this.getPresionArterial}}</td>
      </tr>
      <tr>
        <td>GLUCOSA:</td>
        <td>{{this.$store.state.anamnesis.signosVitales[13].valor}}</td>
        <td>{{this.getGlucosa}}</td>
      </tr>
      <tr>
        <td colspan="2">SUMA:</td>
        <td>
        {{getSum}}</td>
      </tr>
      <tr>
        <td colspan="2">SD METABÓLICO:</td>
        <td><b>{{result}}</b></td>
      </tr>
      </tbody></table>
    <center><h3><b>Score síndrome metabólico</b></h3></center>
    <center><table border="1" style="text-align:center">
      <tbody><tr>
        <td colspan="3"><b>Perímetro abdominal</b></td>
      </tr>
      <tr>
        <td><b>Pts</b></td>
        <td><b>Cm M</b></td>
        <td><b>Cm F</b></td>
      </tr>
      <tr>
        <td>1</td>
        <td>[&gt;= 102]</td>
        <td>[&gt;= 88]</td>
      </tr>
      <tr>
        <td>0</td>
        <td>[&lt; 102]</td>
        <td>[&lt; 88]</td>
      </tr>
      </tbody></table></center>
    <center><table border="1" style="text-align:center">
      <tbody><tr>
        <td colspan="2"><b>Trigliceridos</b></td>
      </tr>
      <tr>
        <td><b>Pts</b></td>
        <td><b>(mg/dl) M y F</b></td>
      </tr>
      <tr>
        <td>1</td>
        <td>[&gt;= 150]</td>
      </tr>
      <tr>
        <td>0</td>
        <td>[&lt; 150]</td>
      </tr>
      </tbody></table></center>
    <center><table border="1" style="text-align:center">
      <tbody><tr>
        <td colspan="3"><b>HDL</b></td>
      </tr>
      <tr>
        <td><b>Pts</b></td>
        <td><b>(mg/dl) M</b></td>
        <td><b>(mg/dl) F</b></td>
      </tr>
      <tr>
        <td>0</td>
        <td>[&gt;= 40]</td>
        <td>[&gt;= 50]</td>
      </tr>
      <tr>
        <td>1</td>
        <td>[&lt; 40]</td>
        <td>[&lt; 50]</td>
      </tr>
      </tbody></table></center>
    <center><table border="1" style="text-align:center">
      <tbody><tr>
        <td colspan="2"><b>Presión arterial</b></td>
      </tr>
      <tr>
        <td><b>Pts</b></td>
        <td><b>(mmHg) M y F</b></td>
      </tr>
      <tr>
        <td>1</td>
        <td>[&gt;= 130 ó &gt;= 85]</td>
      </tr>
      <tr>
        <td>0</td>
        <td>[&lt; 130 y &lt; 85]</td>
      </tr>
      </tbody></table></center>
    <center><table border="1" style="text-align:center">
      <tbody><tr>
        <td colspan="2"><b>Glucosa</b></td>
      </tr>
      <tr>
        <td><b>Pts</b></td>
        <td><b>(mg/dl) M y F</b></td>
      </tr>
      <tr>
        <td>1</td>
        <td>[&gt;= 100]</td>
      </tr>
      <tr>
        <td>0</td>
        <td>[&lt; 100]</td>
      </tr>
      </tbody></table></center>
    <center><table border="1" style="text-align:center">
      <tbody><tr>
        <td colspan="2"><b>SD METABÓLICO</b></td>
      </tr>
      <tr>
        <td><b>Suma</b></td>
        <td><b>Resultado</b></td>
      </tr>
      <tr>
        <td>[&gt;=3]</td>
        <td bgcolor="#FF0000">SI</td>
      </tr>
      <tr>
        <td>[&lt; 3]</td>
        <td bgcolor="#01DF01">NO</td>
      </tr>
      </tbody></table></center>
      <v-btn
              @click="print" dark color="primary">Imprimir
      </v-btn>
    </div>
  </v-container>
</template>
<script>


  export default {
    data () {
      return {
        search: '',
        valid: false,
        requiredField:[v => !!v || 'Es requerido'],
        dialog: false,
        editedIndex: -1,
        result:"NO"
      };
    },methods:{
      print(){
        var divToPrint=document.getElementById('divPrint');
        var newWin=window.open('','Print-Window');
        newWin.document.open();
        newWin.document.write('<html><body onload="window.print()">'+divToPrint.innerHTML+'</body></html>');
        newWin.document.close();
        setTimeout(function(){newWin.close();},10);
      }

    },
      computed : {
      getSum(){
        let a1=this.getPerimetro
        let a2=this.getTrigliceridos
        let a3=this.getHdl
        let a4=this.getPresionArterial
        let a5= this.getGlucosa
        let resultNumber=a1+a2+a3+a4+a5
        if(resultNumber>=3){
          this.result="SI"
        }
        return resultNumber
      },
        getPerimetro(){
          if(this.$store.state.patient.gender=="M"){
            return this.$store.state.anamnesis.signosVitales[9].valor>=102?1:0
          }else{
            return this.$store.state.anamnesis.signosVitales[9].valor>=88?1:0
          }
        },
        getTrigliceridos(){
            return this.$store.state.anamnesis.signosVitales[11].valor>=150?1:0
        },
        getHdl(){
          if(this.$store.state.patient.gender=="M"){
            return this.$store.state.anamnesis.signosVitales[12].valor>=40 ? 0:1
          }else{
            return this.$store.state.anamnesis.signosVitales[12].valor>=50 ? 0:1
          }
        },
        getPresionArterial(){
          return (this.$store.state.anamnesis.signosVitales[1].valor>=130 || this.$store.state.anamnesis.signosVitales[2].valor>=85) ?1:0
        },

        getGlucosa(){
          return this.$store.state.anamnesis.signosVitales[13].valor>=100 ?1:0
        },


      },
    beforeCreate() {
      this.$store.dispatch('getPatientAnamnesisByRouteSheets',this.$store.state.routeSheet.id).then(response => {
        for(let i=0; i<this.$store.state.anamnesisList.length;i++){
          this.$store.state.anamnesis=JSON.parse(this.$store.state.anamnesisList[i].value)
        }
      }, error => {
        this.$store.state.progress = false;
        this.$store.state.dialogError = true;
      })

      this.$store.dispatch('getPatientJobAndHealthByRouteSheets',this.$store.state.routeSheet.id).then(response => {
        for(let i=0; i<this.$store.state.workAndHealthList.length;i++){
          this.$store.state.anexoSaludTrabajo=JSON.parse(this.$store.state.workAndHealthList[i].value)
        }
      }, error => {
        this.$store.state.progress = false;
        this.$store.state.dialogError = true;
      })
    },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/patient/monitoreo/metabolico/ScoreSd.vue